import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import {
  UtensilsCrossed,
  FileCheck2,
  Package as PackageIcon,
  Plane,
  BookOpen,
  BedDouble,
  Bus,
  GraduationCap,
} from "lucide-react";

const FASILITAS = [
  { key: "meal",       Icon: UtensilsCrossed, id: "Konsumsi Jamaah",   en: "Meals",           desc_id: "Menu Indonesia 3x sehari selama program.",       desc_en: "3 daily Indonesian meals throughout the program." },
  { key: "visa",       Icon: FileCheck2,     id: "Visa Umroh",         en: "Umrah Visa",      desc_id: "Pengurusan visa umroh oleh tim Batik Travel.",   desc_en: "Umrah visa processed by the Batik Travel team." },
  { key: "kit",        Icon: PackageIcon,    id: "Perlengkapan Umroh", en: "Umrah Kit",       desc_id: "Koper, ihram, buku doa, dan perlengkapan lengkap.", desc_en: "Suitcase, ihram, prayer book, and complete kit." },
  { key: "flight",     Icon: Plane,          id: "Tiket Pesawat PP",   en: "Round-trip Flight", desc_id: "Tiket penerbangan pergi-pulang sesuai maskapai program.", desc_en: "Round-trip flight ticket per the selected package." },
  { key: "ustadz",     Icon: GraduationCap,  id: "Ustadz / Muthawif",  en: "Ustadz / Guide",  desc_id: "Bimbingan ustadz & muthawif berpengalaman di Tanah Suci.", desc_en: "Guidance from experienced ustadz & muthawif in the Holy Land." },
  { key: "hotel",      Icon: BedDouble,      id: "Hotel Penginapan",   en: "Hotel Stay",      desc_id: "Akomodasi hotel nyaman, mulai reguler hingga bintang 5 pelataran.", desc_en: "Comfortable hotels — from regular to 5-star next to the mosque." },
  { key: "transport",  Icon: Bus,            id: "Transportasi",       en: "Transportation",  desc_id: "Bus AC & transportasi darat selama program di Tanah Suci.", desc_en: "AC bus & ground transport throughout the program." },
  { key: "manasik",    Icon: BookOpen,       id: "Manasik Umroh",      en: "Umrah Practice",  desc_id: "Sesi pembekalan manasik sebelum berangkat.",     desc_en: "Practice session before departure." },
];

export default function FasilitasSection() {
  const { lang, t } = useLang();
  return (
    <section className="py-24 lg:py-32 bg-muted/30" data-testid="fasilitas-section">
      <div className="container-x">
        <header className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-4 mb-4">
            <span className="h-px w-10 bg-accent" />
            <p className="overline">{t("fasilitas.overline")}</p>
            <span className="h-px w-10 bg-accent" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-primary tracking-tight">{t("fasilitas.title")}</h2>
          <p className="mt-5 text-muted-foreground text-lg">{t("fasilitas.sub")}</p>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {FASILITAS.map(({ key, Icon, id, en, desc_id, desc_en }, i) => (
            <div
              key={key}
              data-testid={`fasilitas-${key}`}
              className="group bg-card border border-border rounded-xl p-6 lg:p-7 hover:shadow-lg hover:-translate-y-1 hover:border-accent transition-all duration-300 anim-fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent group-hover:scale-110 transition-all duration-300">
                <Icon className="h-5 w-5 text-accent group-hover:text-primary transition-colors" />
              </div>
              <h3 className="font-serif text-lg text-primary leading-snug mb-2">{lang === "id" ? id : en}</h3>
              <p className="text-xs lg:text-sm text-muted-foreground leading-relaxed">
                {lang === "id" ? desc_id : desc_en}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
